// components/modals/InviteTeamMember.tsx
import { FC, useState } from "react";
import { useAppSelector } from "@/redux/hooks/hooks";
import { CustomButton } from "@/components/ui/Buttons";
import InputField from "../form/InputField";
import { useInviteMemberMutation } from "@/redux/feature/invite/inviteApi";
import { handleApiRequest } from "@/utils/handleApiRequest";
import toast from "react-hot-toast";

type Props = {
  setOpen: (val: boolean) => void;
};

const InviteTeamMember: FC<Props> = ({ setOpen }) => {
  const mainUserEmail = useAppSelector((state) => state.auth.user?.email);
  const [email, setEmail] = useState("");

  const [inviteMember, { isLoading }] = useInviteMemberMutation();

  const handleSubmit = async () => {
    const payload = {
      mainUserEmail: mainUserEmail,
      invitedEmail: email,
    };

    await handleApiRequest({
      payload: payload,
      requestFunction: inviteMember,
      onSuccess: () => {
        toast.success("Invitation Sent!");
        setOpen(false)
      },
      onError: (err) => {
        const error = err as { data?: { errorSource?: { message: string }[] } };
        if (error?.data) {
          error?.data?.errorSource?.forEach((item) =>
            toast.error(item.message)
          );
        } else {
          toast.error("Some Thing Went Wrong");
        }
      },
    });
  };

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Invite a Team Member</h2>
      <InputField
        name="Invite Member"
        label="Email Address"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <div className="flex justify-end gap-x-2">
        <CustomButton
          variant="outline"
          color="#666666"
          
          onClick={() => setOpen(false)}
          padding="8px 14px"
        >
          Cancel
        </CustomButton>
        <CustomButton disabled={isLoading} onClick={handleSubmit} padding="8px 14px">
          {
            isLoading ? 'Inviting':"Send Invite"
          }
        </CustomButton>
      </div>
    </div>
  );
};

export default InviteTeamMember;
